'use client'

import { Button, Icon, type ButtonProps } from '../../components'
import { useCopy } from '../../hooks'

interface CopyButtonProps extends ButtonProps {
  nonActiveTitle?: string
  activeMessageTitle?: string
  text: string
}

export const CopyButton = ({
  nonActiveTitle = 'Copy',
  activeMessageTitle = 'Copied',
  text,
  ...props
}: CopyButtonProps) => {
  const { copy, message } = useCopy(activeMessageTitle)
  const handleCopy = () => {
    copy(text)
  }
  return (
    <Button
      onClick={handleCopy}
      color='neutral'
      size='sm'
      variant='ghost'
      className='min-w-[72px]'
      type='button'
      startIcon={!message ? <Icon name='Copy' size='sm' /> : undefined}
      {...props}
    >
      {message || nonActiveTitle || 'Copy'}
    </Button>
  )
}
